import React, { useEffect, useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ProfileMain from "../profile/ProfileMain";
import DefaultLoader from "../../components/loader/DefaultLoader";
import RecentGameMain from "../profile/RecentGameMain";
import NextSeriesMain from "../profile/NextSeriesMain";
import TrackmanChartMain from "../record/TrackmanChartMain";
import SprayChartMain from "../record/SprayChartMain";
import DamageChartMain from "../record/DamageChartMain";
import PitchLocationMain from "../record/PitchLocationMain";
import RecordTableMain from "../record/RecordTableMain";
import SeriesMain from '../series/SeriesMain';
import MovingChartMain from "../record/MovingChartMain";
import BatterRecordTableMain from "../record/BatterRecordTableMain";
import BatterIndicatorMain from "../profile/BatterIndicatorMain";
import SprayBattingChartMain from "../record/SprayBattingChartMain";

function MajorLeagueBatterArea({profile}) {
    const style={
        height: '450px',
        display: 'flex',
        flexDirection: 'column'
    }

    return (
        <>
        <Row>
            <Col md={3} className="digestDivBox" id="playerProfile">
                {
                    profile['teamId'] ? 
                    <ProfileMain profile={profile} leagueType={4201}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                }
            </Col>
            <Col id="gameSchedule" className="digestDivBox">
                {
                    profile['teamId'] ? 
                    <BatterIndicatorMain profile={profile} leagueType={4201}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                }
            </Col>
            <Col id="last7games" className="digestDivBox">
                {   
                    profile['teamId'] ? 
                    <RecentGameMain profile={profile} leagueType={4201}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                }
                {/* {
                    profile['teamId'] ? 
                    <NextSeriesMain profile={profile}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                } */}
            </Col>
        </Row>
        {/* <Row>
            {
                profile['teamId'] ? 
                <SeriesMain profile={profile}/> :
                <Col md={12} >
                    <div style={{height: '300px'}}>
                        <DefaultLoader/>
                    </div>
                </Col>
            }
        </Row> */}
        <Row>
            <Col id="spreadChartZone" className="digestDivBox" style={{position:'relative'}}>
            {
                profile['teamId'] ?
                <SprayBattingChartMain profile={profile} /> :
                <DefaultLoader/>
            }
            </Col>
        </Row>
        <Row>
            <Col id="chartZone1" className="digestDivBox" style={{position:'relative'}}>
                <div style={style}>
                    {
                        profile['teamId'] ? 
                        <TrackmanChartMain profile={profile} /> :
                        <DefaultLoader/>
                    }
                </div>
            </Col>
            <Col id="chartZone2" className="digestDivBox" style={{position:'relative'}}>
                <div style={style}>
                    {
                        profile['teamId'] ?
                        <SprayChartMain profile={profile} /> :
                        <DefaultLoader/>
                    }
                </div>
            </Col>
        </Row>
        <Row>
            <Col id="movingChartZone" className="digestDivBox" style={{position:'relative'}}>
                {
                    profile['teamId'] ?
                    <MovingChartMain profile={profile} /> :
                    <DefaultLoader/>
                }
            </Col>
        </Row>
        <Row>
            <Col id="damageMap" className="digestDivBox2" style={{position:'relative', minWidth: '100%'}}>
            {
                profile['teamId'] ?
                <DamageChartMain profile={profile} /> :
                <DefaultLoader/>
            }
            </Col>
            <Col id="pitchLocation" className="digestDivBox2" style={{position:'relative', minWidth: '100%'}}>
            {
                profile['teamId'] ?
                <PitchLocationMain profile={profile} /> :
                <DefaultLoader/>
            }
            </Col>
        </Row>
        <Row>
            <div id="tableContainer">
            {
                profile['teamId'] ?
                <BatterRecordTableMain profile={profile}/> :
                <div style={{height: '200px'}}>
                    <DefaultLoader/>
                </div>
            }
            </div>
        </Row>
        </>
    )
}

export default MajorLeagueBatterArea;